import { checkElement, createElement } from '@core/helpers';
import { formatCurrency } from 'src/app/core/helpers/format-currency';
import { transformTimeCF } from 'src/app/project/modules/custom-fields/custom-field-time/custom-field-time-transformer';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { TPoint } from 'src/app/project/modules/points/points.model';
import { TColumn } from '../../../columns/column.model';
import { GET_CF_SUM } from '../../custom-field-sums.store';
import { GET_TABLE } from '../../../table.ui.store';
import { calculateGroupedHeaderSum, manuallyCalculateSum } from './calculate-grouped-header-sum';
import { createFooterTooltip } from './create-footer-tooltip';

export const createNumberCostDateInnerCell = ({
  cellNameElement,
  column,
  points,
  isGroupedHeader = false,
  _index,
  type,
}: {
  cellNameElement: HTMLElement;
  column: TColumn;
  points: TPoint[];
  isGroupedHeader?: boolean;
  _index?: number;
  type: 'NUMBERS' | 'COST' | 'TIME';
}): void => {
  const table = GET_TABLE();
  const customFields = GET_CUSTOM_FIELDS();

  cellNameElement.classList.add('table__head__cell--innerSum');

  let value = 0;

  const sumValue = GET_CF_SUM();

  if (sumValue && sumValue?.length > 0) {
    const total = sumValue.find((sum) => {
      const matchingValue = column.customFieldIds?.length ? column.customFieldIds[0] : column.name;
      return sum.key === matchingValue;
    });

    if (isGroupedHeader) {
      const item = table.items[_index];
      value = calculateGroupedHeaderSum(item, total);
    } else {
      value = total?.total ?? 0;
    }
  } else {
    const searchedPoints = points ? points : table.getPoints();
    value = manuallyCalculateSum(searchedPoints, column);
  }

  let formattedValue = '';

  if (type === ECustomFieldType.NUMBERS) {
    const symbol = customFields[column.customFieldIds[0]].unit
      ? customFields[column.customFieldIds[0]].unit
      : '';

    formattedValue = formatCurrency(
      value,
      symbol,
      +customFields[column.customFieldIds[0]].decimalPlaces,
    );
  }

  if (type === ECustomFieldType.COST) {
    const costCurrencySymbol = customFields[column.customFieldIds[0]].currencySymbol;

    const decimalPlaces =
      customFields[column.customFieldIds[0]].type === ECustomFieldType.COST
        ? 2
        : +customFields[column.customFieldIds[0]].decimalPlaces;

    formattedValue = formatCurrency(value, costCurrencySymbol, decimalPlaces);
  }

  if (type === ECustomFieldType.TIME) {
    const showHoursOnly = customFields[column.customFieldIds[0]].showHoursOnly;
    formattedValue = transformTimeCF(value, showHoursOnly);
  }

  const valueElement = createElement<HTMLElement>('span', {
    attrs: {
      class: 'site-table__total',
    },
    children:
      type === ECustomFieldType.TIME
        ? [formattedValue ? formattedValue : '0d / 00:00']
        : [formattedValue],
  });

  cellNameElement.appendChild(checkElement(valueElement));

  createFooterTooltip(formattedValue, valueElement);
};
